export const deprecatedLogoId = { backgroundImage: 'deprecatedLogoBackgroundImage' };
